import axios from 'axios';

export const BASE_URL = '/charts';

export const getInsightsOverview = async (params) => {
  return axios.get(`${BASE_URL}/insightsOverview`, { params });
};

export const getSalesTrend = async (params) => {
  return axios.get(`${BASE_URL}/salesTrend`, { params });
};

export const getCustomersOverview = async (params) => {
  return axios.get(`${BASE_URL}/customerOverview`, { params });
};

export const getOperationsOverview = async (params) => {
  return axios.get(`${BASE_URL}/operationsOverview`, { params });
};

export const getEngagementOverview = async (params) => {
  return axios.get(`${BASE_URL}/engagementOverview`, { params });
};

export const getProductHighlights = async (params) => {
  return axios.get(`${BASE_URL}/productMetrics`, { params });
};
